import React, { useState } from 'react';
import CollapseMenu from '../../../../BaseModule/Components/CollapseMenu/CollapseMenu';
import LinkButton from '../../../../BaseModule/Components/Button/LinkButton/LinkButton';

// @ts-ignore
import styles from './UserFamilyMemberCollapseMenu.module.scss';
import apiClient from '../../../../../Services/ApiClient';
import { useAppContext } from '../../../../../Services/AppContext';
import NetteApiClient from '../../../../../Services/NetteApiClient';
import RemoveConfirmationModal from '../../../../BaseModule/Components/RemoveConfirmation/RemoveConfirmationModal';
import ShareChildrenModal from '../../../../Family/Components/ShareChildren/ShareChildrenModal/ShareChildrenModal';
import { useFamilyMemberQuery } from '../../../../../graphql/graphql';
import Loading from '../../../../BaseModule/Components/Loading';

interface Props {
	userId: string;
	familyMemberUserId: string;
	familyMemberId: number;
	allowShareChildren: boolean;
}

const UserFamilyMemberCollapseMenu: React.FC<Props> = ({
	userId,
	familyMemberUserId,
	familyMemberId,
	allowShareChildren = false,
}) => {
	// @ts-ignore
	const { redirectUserFamilyList } = useAppContext();
	const [isMemberRemoveConfirmationOpen, setIsMemberRemoveConfirmationOpen] =
		useState(false);
	const [isChildrenShareOpen, setIsChildrenShareOpen] = useState(false);

	const { data, isLoading } = useFamilyMemberQuery({ id: familyMemberId });

	const handleRemoveFromFamily = async () => {
		await apiClient.delete(`/patients/${userId}/family/${familyMemberUserId}`);
		setIsMemberRemoveConfirmationOpen(false);
		if (redirectUserFamilyList) {
			NetteApiClient.get(redirectUserFamilyList);
		}
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<>
			<CollapseMenu>
				{data?.familyMember?.canBeDeleted ? (
					<LinkButton
						text='component.userFamilyMemberCollapseMenu.removeFromFamily'
						onClick={() => setIsMemberRemoveConfirmationOpen(true)}
						theme='purple'
					/>
				) : (
					<></>
				)}
				{allowShareChildren && data?.familyMember?.canBeShared ? (
					<LinkButton
						text='component.userFamilyMemberCollapseMenu.shareChildrenProfile'
						onClick={() => setIsChildrenShareOpen(true)}
						theme='purple'
					/>
				) : (
					<></>
				)}
			</CollapseMenu>
			{isMemberRemoveConfirmationOpen && (
				<RemoveConfirmationModal
					opened
					onClose={() => setIsMemberRemoveConfirmationOpen(false)}
					onConfirm={handleRemoveFromFamily}
					confirmationText='component.userFamilyMemberCollapseMenu.areYouSureThatYouWantToRemoveMemberFromFamily'
				/>
			)}
			{isChildrenShareOpen && (
				<ShareChildrenModal
					isOpen
					childrenId={familyMemberUserId}
					onClose={() => setIsChildrenShareOpen(false)}
				/>
			)}
		</>
	);
};

export default UserFamilyMemberCollapseMenu;
